module.exports = __webpack_public_path__ + "img/p5.e1068909.png";